module.exports = __webpack_public_path__ + "img/levels-100_small.d00c73a5.png";